import React, { useEffect, useRef, useState } from 'react';
import style from './xscroll.module.css';
import { useDebounce } from '../../../utils/hooks.js';

const XScroll = React.forwardRef(
    ({ customStyle, children, scrollBar, scrollBarType, contentStyle, containerHeights, selfid = 'defalut' }, ref) => {
        const [wrapperWidth, setWrapperWidth] = useState(0);
        const [wrapperHeight, setWrapperHeight] = useState(0);
        const [scrollbarPosition, setScrollbarPosition] = useState(0)
        const [mouseDownFlag, setMoseDownFlag] = useState(false)
        const [showBar, setShowBar] = useState(scrollBar)
        const wrapperRef = useRef(null);
        const showBarClearId = useRef(null);

        useEffect(() => {
            const scrollBox = document.querySelector(`#scrollBox${selfid}`);
            let startX;
            let startScrollTop;

            const touchStart = (event) => {
                startX = event.touches[0].pageX;
                startScrollTop = scrollBox.scrollTop;
            };
            const touchMove = (event) => {
                const currentX = event.touches[0].pageX;
                const diffX = startX - currentX;
                scrollBox.scrollTop = startScrollTop + diffX;

                // 创建并触发一个模拟的wheel事件
                const wheelEvent = new WheelEvent('wheel', {
                    deltaX: diffX, // 模拟横向滑动的位移作为deltaX
                    deltaY: 0, // Y方向位移为0
                    clientX: currentX,
                    clientY: event.touches[0].clientY,
                    bubbles: true,
                    cancelable: true,
                });
                scrollBox.dispatchEvent(wheelEvent);
                event.preventDefault();
            };
            const wheel = (event) => {
                if (event.deltaX) {
                    event.preventDefault(); // 防止左右回退
                    scrollBox.scrollTop += event.deltaX;
                }
            };
            window.addEventListener('resize', debounceWheel, { passive: false });
            scrollBox.addEventListener('touchstart', touchStart, { passive: false });
            scrollBox.addEventListener('touchmove', touchMove, { passive: false });
            scrollBox.addEventListener('wheel', wheel, { passive: false });
            return () => {
                window.removeEventListener('resize', debounceWheel, { passive: false });
                scrollBox.removeEventListener('touchstart', touchStart, { passive: false });
                scrollBox.removeEventListener('touchmove', touchMove, { passive: false });
                scrollBox.removeEventListener('wheel', wheel, { passive: false });
            };
        }, []);

        useEffect(() => {
            setShowBar(scrollBar)
        }, [scrollBar])


        const handleResize = () => {
            if (wrapperRef.current) {
                const { width, height } = wrapperRef.current.getBoundingClientRect();
                setWrapperWidth(width);
                setWrapperHeight(height);
            }
        };

        useEffect(() => {
            debounceWheel();
        }, [wrapperRef]);

        const handlerScroll = (e) => {
            if (mouseDownFlag) return
            if (scrollBarType === 'scroll') {
                setShowBar(true)
                clearTimeout(showBarClearId.current)
                showBarClearId.current = setTimeout(() => {
                    setShowBar(false)
                }, 1500);
            }
            const MaxScrollLength = e.target.scrollHeight - e.target.clientHeight
            const assignAbleLength = e.target.clientHeight - 100
            setScrollbarPosition(e.target.scrollTop / MaxScrollLength * assignAbleLength)
        }

        const debounceWheel = useDebounce(handleResize, 300);

        const handlerMoveStart = (event) => {
            setMoseDownFlag(true)
            if (event.button !== 0) return;
            if (scrollBarType === 'scroll') {
                clearTimeout(showBarClearId.current)
            }
            const startX = event.clientX;
            const scrollBox = document.querySelector(`#scrollBox${selfid}`)
            const MaxScrollLength = scrollBox.scrollHeight - scrollBox.clientHeight
            const assignAbleLength = scrollBox.clientHeight - 100
            const maxDiffX = wrapperWidth - 100
            document.onmousemove = function (e) {
                const endX = e.clientX;
                let diffX = endX - startX + scrollbarPosition;
                if (diffX < 0) {
                    diffX = 0
                }
                if (diffX > maxDiffX) {
                    diffX = maxDiffX
                }
                setScrollbarPosition(diffX)
                scrollBox.scrollTo({ top: diffX / assignAbleLength * MaxScrollLength })
            }
            document.onmouseup = function () {
                setMoseDownFlag(false)
                if (scrollBarType === 'scroll') {
                    showBarClearId.current = setTimeout(() => {
                        setShowBar(false)
                    }, 2000);
                }
                document.onmousemove = null;
                document.onmouseup = null;
            }
            if (event.preventDefault) {
                event.preventDefault();
            }
        }

        return (
            <div
                style={customStyle}
                className={style.wrapper}
                ref={wrapperRef}>
                {/* 关键点：
                        1.动态获取父容器的宽高
                        2.设置子容器的宽度为父容器的高度，高度为父元素的宽度
                        3.旋转子容器，注意旋转中心如何改变
                    */}
                <div
                    onScroll={handlerScroll}
                    className={`${style.scrollBox} ${showBar ? style.showBar : style.hideBar
                        }`}
                    //天坑，generate和prod页面刚生成的时候是覆盖的，所以直接拿id拿的是generate中的Xscroll，导致滑动失效
                    id={"scrollBox" + selfid}
                    ref={ref}
                    style={{
                        width: containerHeights ? containerHeights + 7 : wrapperHeight,
                        height: wrapperWidth,
                        transform: `translateY(${containerHeights ? containerHeights : wrapperHeight}px) rotate(-90deg)`,
                    }}
                >
                    <div
                        className={style.content}
                        style={
                            contentStyle === 'widthAuto'
                                ? {
                                    width: wrapperWidth,
                                    height: 'auto',
                                    left: containerHeights ? containerHeights : '100%'
                                }
                                : {
                                    width: '100%',
                                    height: 'fit-content',
                                    left: containerHeights ? containerHeights : '100%'
                                }
                        }
                    >
                        {wrapperRef.current && children}
                    </div>
                </div>
                <div
                    onMouseDown={handlerMoveStart}
                    className={style.scrollBar}
                    style={showBar ? { left: scrollbarPosition } : { display: 'none' }}>
                </div>
            </div>
        );
    },
);

XScroll.displayName = "XScroll"
export { XScroll };
